var React = require('react');

function Logo (props) {
    return React.createElement("svg",props,React.createElement("rect",{"width":"117","height":"162"}));
}

Logo.defaultProps = {"width":"117","height":"162","viewBox":"0 0 117 162","fill":"none"};

module.exports = Logo;

Logo.default = Logo;
